import { getOnlineMeetingProviderInfo } from './getOnlineMeetingProviderInfo';
import { OnlineMeetingProviderType } from './OnlineMeetingProviderType';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { joinSkypeMeetingButton } from 'owa-locstrings/lib/strings/joinskypemeetingbutton.locstring.json';
import { joinTeamsMeetingButton } from 'owa-locstrings/lib/strings/jointeamsmeetingbutton.locstring.json';
import { onlineSkypeMeetingLocationLabel } from 'owa-locstrings/lib/strings/onlineskypemeetinglocationlabel.locstring.json';
import { onlineTeamsMeetingLocationLabel } from 'owa-locstrings/lib/strings/onlineteamsmeetinglocationlabel.locstring.json';

export function getIconFromProviderName(provider: OnlineMeetingProviderType) {
    switch (provider) {
        case 'SkypeForBusiness': {
            return ControlIcons.SkypeForBusinessLogo16;
        }
        case 'SkypeForConsumer': {
            return ControlIcons.SkypeLogo16;
        }
        case 'TeamsForBusiness': {
            return ControlIcons.TeamsLogo;
        }
    }

    return null;
}

export function getJoinMeetingLabelFromProviderName(provider: OnlineMeetingProviderType) {
    switch (provider) {
        case 'SkypeForBusiness': {
            return loc(joinSkypeMeetingButton);
        }
        case 'SkypeForConsumer': {
            return loc(joinSkypeMeetingButton);
        }
        case 'TeamsForBusiness': {
            return loc(joinTeamsMeetingButton);
        }
    }

    return null;
}

/**
 * Gets the online provider label shown in the online providers drop down
 * @param provider of the online meeting
 * @returns the text used in the online provider dropdown
 */
export function getOnlineProviderLabel(provider: OnlineMeetingProviderType): string {
    let onlineProviderLabel;

    switch (provider) {
        case 'SkypeForBusiness':
        case 'SkypeForConsumer': {
            onlineProviderLabel = loc(onlineSkypeMeetingLocationLabel);
            break;
        }
        case 'TeamsForBusiness':
            onlineProviderLabel = loc(onlineTeamsMeetingLocationLabel);
            break;
    }

    return onlineProviderLabel;
}

/**
 * Gets whether a online provider type is a supported type by OWA
 * @param provider of the online meeting
 * @returns whether the provide is a supported type by OWA
 */
export function isSupportedOnlineMeetingProvider(provider: string): boolean {
    return (
        provider === 'SkypeForBusiness' ||
        provider === 'SkypeForConsumer' ||
        provider === 'TeamsForBusiness'
    );
}

export function getOnlineMeetingIconName(item: CalendarEvent): string {
    if (item.OnlineMeetingProvider) {
        return getIconFromProviderName(item.OnlineMeetingProvider as OnlineMeetingProviderType);
    }

    const providers = getOnlineMeetingProviderInfo(item);
    if (!providers) {
        return null;
    }

    if (providers.length >= 2) {
        return ControlIcons.Video;
    } else if (providers.length === 1 && isSupportedOnlineMeetingProvider(providers[0])) {
        return getIconFromProviderName(providers[0]);
    }

    return null;
}
